import settings from './settings.js'
import socket from './socket.js'
import {reactive} from 'vue'
import * as extendObject from 'extend'
import userFns from './user-functions.js'

const account = reactive({
	priv: {
		name: '',
		email: '',
		credit: 0,
		totalCredit: 0,
		maxChars: 10,
		perks: {},
		badges: {},
		choiceUsed: 0
	},
	props: {
		access: 0,
		accid: 0
	},
	settings,
	userids: [],
	deletedUserids: [],
	users: [],
	deletedUsers: [],
	ignores: [],
	transactions: []
})

console.log( 'socket', socket )

socket.on( 'account', ( data ) => {
	console.log( 'account data', data )
	if( data.props && data.props.accid ){
		account.settings.accid = data.props.accid
	}

	if( !localStorage['2019refractor'] ){
		localStorage.clear()
		localStorage['2019refractor'] = true
	}

	if( data.props ){
		for( const key in data.props ){
			account.props[key] = data.props[key]
		}
	}

	if( data.priv ){
		for( const key in data.priv ){
			if( typeof data.priv[key] === 'object' ){
				extendObject( true, account.priv[key], data.priv[key] )
			} else {
				account.priv[key] = data.priv[key]
			}
		}
	}

	if( localStorage[account.props.accid + '-settings'] ){
		const loadedSettings = JSON.parse( localStorage[account.props.accid + '-settings'] )

		Object.entries( loadedSettings ).forEach( ( [prop, key] ) => {
			account.settings[prop] = key
		})
	}

	socket.emit( 'request-session' )
})

socket.on( 'account-users', ( data ) => {
	if( data.ids ){
		data.ids.forEach( ( newId ) => {
			if( account.userids.indexOf( newId ) === -1 ){
				account.userids.unshift( newId )
				userFns.getById( newId, ( user ) => {
					if( account.users.length === 0 || user.props.name > account.users[0].props.name ){
						account.users.push( user )
					} else {
						account.users.unshift( user )
					}
				})
			}
		})
	}
})

socket.on( 'ignores', function( data ){
	account.ignores = [...new Set( [...account.ignores, ...data.ids] )] //unique combine / _.union
})

global.account = account

export default account
